import { SxProps, Theme } from '@mui/material';

type TStyles = {
  icon: SxProps<Theme>;
  block: SxProps<Theme>;
  infoText: SxProps<Theme>;
};

export const styles: TStyles = {
  block: () => ({
    display: 'flex',
    gap: '15px',
    backgroundColor: 'var(--main-color-with-opacity-03)',
    padding: '12px',
    width: '100%',
  }),
  icon: (theme: Theme) => ({
    position: 'relative',
    color: theme.palette.primary.main,
  }),
  infoText: {
    textAlign: 'start',
    fontSize: '14px',
  },
};
